/**
 * 圧縮イベント表示カード（管理アプリ用）
 *
 * コンテキスト圧縮の統計情報を表示し、要約内容を折りたたみで閲覧できる。
 */

import { formatTokenCount } from '@kyumo/shared-ui';
import { ChevronDown, Shrink } from 'lucide-react';
import { useState } from 'react';
import { MarkdownContent } from './MarkdownContent';
import type { CompressionPart } from './task-detail-types';

export function CompressionCard({ part }: { part: CompressionPart }) {
  const { stats, summaryText } = part;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="rounded-lg border border-dashed border-violet-500/40 bg-violet-500/5 text-sm">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex w-full items-center gap-3 px-4 py-2 cursor-pointer hover:bg-violet-500/10 transition-colors"
      >
        <Shrink className="w-4 h-4 shrink-0 text-violet-400" />
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-muted-foreground">
          <span className="font-medium text-violet-300">コンテキスト圧縮</span>
          <span>
            圧縮前コンテキスト: {formatTokenCount(stats.beforeTokens)}(
            {Math.round(stats.beforeUsagePercent)}%)
          </span>
          <span>
            圧縮前会話: {stats.compressedMessageCount}件 → 要約{' '}
            {formatTokenCount(stats.summarizationUsage.outputTokens)} + 保持{' '}
            {stats.retainedMessageCount}件
          </span>
        </div>
        {summaryText && (
          <ChevronDown
            className={`w-4 h-4 shrink-0 ml-auto text-muted-foreground transition-transform ${isOpen ? 'rotate-180' : 'rotate-0'}`}
          />
        )}
      </button>
      {isOpen && summaryText && (
        <div className="border-t border-violet-500/20 px-4 py-3">
          <div className="prose dark:prose-invert prose-sm max-w-none text-muted-foreground">
            <MarkdownContent content={summaryText} />
          </div>
        </div>
      )}
    </div>
  );
}
